import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Tile, TileProps } from '@/features/markets/components/summary-tile/components/Tile'

interface SummaryTileProps {
  variant: 'total-volume' | 'total-earnings' | 'total-liquidation'
  USDValue: NormalizedUnitNumber
  'data-testid'?: string
}

export function SummaryTile({ variant, USDValue, 'data-testid': dataTestId }: SummaryTileProps) {
  return (
    <Tile
      USDValue={USDValue}
      {...tileProps[variant]}
      data-testid={dataTestId}
      className="flex-col items-center sm:flex-row sm:items-start"
      textWrapperClassName="items-center sm:items-start"
    />
  )
}

const tileProps: Record<SummaryTileProps['variant'], Omit<TileProps, 'USDValue' | 'index'>> = {
  'total-volume': {
    title: 'Total volume',
  },
  'total-earnings': {
    title: 'Total earnings',
    mobileTitle: 'Earnings',
  },
  'total-liquidation': {
    title: 'Liquidations',
  },
}
